// Intercepts pagination clicks inside [data-collection-products-container] on
// collection pages and swaps in the new page's products via fetch, instead of
// a full page reload. Shows a loading overlay while fetching and updates the
// URL (history) so back/forward and sharing links still work.
function getContainer() {
  return document.querySelector('[data-collection-products-container]');
}

async function loadPage(url) {
  const container = getContainer();
  if (!container) return;

  const loader = container.querySelector('[data-collection-loader]');
  if (loader) loader.hidden = false;

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Collection page request failed: ${response.status}`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newContainer = doc.querySelector('[data-collection-products-container]');

    if (newContainer) {
      container.replaceWith(newContainer);
      history.pushState({}, '', url);
      newContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      newContainer.dispatchEvent(new CustomEvent('collection:updated', { bubbles: true }));
    } else {
      window.location.href = url;
    }
  } catch (err) {
    window.location.href = url;
  } finally {
    if (loader) loader.hidden = true;
  }
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-collection-products-container] .collection-products__pagination a');
  if (!link) return;
  event.preventDefault();
  loadPage(link.href);
});

window.addEventListener('popstate', () => {
  if (getContainer()) loadPage(window.location.href);
});
